import { useState } from "react";
import LoginPopup from "~/features/auth/login/components/LoginPopup";
import ResetPasswordPopup from "~/features/auth/login/components/ResetPasswordPopup";

interface Props {
  onClose: () => void;
}

export const SessionExpiredLoginPopup = ({ onClose }: Props) => {
  const [resetPopupOpen, setResetPopupOpen] = useState(false);
  const [email, setEmail] = useState("");

  const openResetPopup = (loginEmail: string) => {
    setEmail(loginEmail);
    setResetPopupOpen(true);
  };

  if (resetPopupOpen) {
    return <ResetPasswordPopup initialEmail={email} close={onClose} />;
  }

  return <LoginPopup initialEmail="" onResetClick={openResetPopup} close={onClose} />;
};
